import ErrorPageContainer from 'layout/ErrorPage/ErrorPageContainer'
import type { ErrorInfo, ReactNode } from 'react'
import React, { Component } from 'react'
import { logger } from 'utils'

interface Props {
  children?: ReactNode
}

class ErrorBoundary extends Component<Props> {
  state = {
    hasError: false,
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const { message, stack } = error
    const { componentStack } = errorInfo

    this.setState({ hasError: true })
    logger.error('appCrash', message, `stack:\n${stack}\n\ncomponent stack:\n${componentStack}`)
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPageContainer />
    }

    return this.props.children
  }
}

export default ErrorBoundary
